import React, { PureComponent } from 'react';
import NavLink from './NavLink';

const FASTRECRUIT_LOGO = require('../../../res/fast-recruit.svg');

export default class FastRecruitLink extends PureComponent {
  render() {
    const { className, style } = this.props;

    return (
      <NavLink
        className={className}
        style={style}
        href={window.config.FASTRECRUIT_URL}
        target='_self'
        page={null}
        id="fastRecruitLink"
      >
        <img
          alt="fastRecruit"
          style={{ height: '100%', ...style }}
          key="fast-recruit-logo"
          className={'fast-scout-name-logo'}
          src={FASTRECRUIT_LOGO}/>
      </NavLink>
    );
  }
}